import { formatBRL, formatISODateTime } from '@/lib/format';
import type { LeadPurchase } from '@/lib/types';

const METHOD_LABELS: Record<string, string> = {
  pix: 'PIX',
  credit_card: 'Cartão',
  multiple_cards: 'Cartões',
  boleto: 'Boleto',
};

/** "ATMOZ · Oferta padrão" — o produto e a oferta, o que houver. */
export const purchaseTitle = (purchase: LeadPurchase): string =>
  [purchase.productName, purchase.offerName].filter(Boolean).join(' · ') || 'Venda na Ephra';

/**
 * As compras do cliente na Ephra, só leitura: vêm de lá e se atualizam
 * sozinhas. Cada linha diz de onde veio a venda (link de qual membro, ou sem
 * link) e se virou comprovante — aí ela conta no ranking do membro.
 */
export function LeadPurchases({ purchases }: { purchases: LeadPurchase[] }) {
  if (purchases.length === 0) return null;
  return (
    <section aria-label="Compras na Ephra" style={{ marginTop: 18 }}>
      <div style={{ fontSize: 13, fontWeight: 500, margin: '0 0 8px' }}>
        Compras na Ephra <span className="muted" style={{ fontWeight: 400 }}>({purchases.length})</span>
      </div>
      <div style={{ border: '1px solid var(--border)', borderRadius: 'var(--radius-md)', overflow: 'hidden', background: 'var(--card)' }}>
        {purchases.map((purchase) => {
          const refunded = purchase.stage === 'REFUNDED';
          return (
            <div key={purchase.id} className={refunded ? 'purchase-line is-refunded' : 'purchase-line'}>
              <span className="num nowrap" style={{ width: 128 }}>{formatISODateTime(purchase.paidAt ?? purchase.purchasedAt)}</span>
              <span className="truncate" style={{ flex: '1 1 160px', minWidth: 0 }} title={purchaseTitle(purchase)}>
                {purchaseTitle(purchase)}
              </span>
              {purchase.memberName ? (
                <span className="chip chip-primary">Link de {purchase.memberName}</span>
              ) : (
                <span className="chip">Sem link de membro</span>
              )}
              {refunded ? <span className="chip chip-negative">Reembolsada</span> : null}
              {purchase.credited ? <span className="chip chip-positive">Virou comprovante</span> : null}
              <span className="muted nowrap" style={{ fontSize: 12 }}>{METHOD_LABELS[purchase.paymentMethod] ?? purchase.paymentMethod}</span>
              <span className="num emphasis nowrap purchase-amount" style={{ fontWeight: 500 }}>{formatBRL(purchase.amount)}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
